import { whiteColor } from '../global';

const organizerPosterListPageStyle = () => ({
    noPadding: {
        '& > div': {
            padding: 0,
        },
    },
    wrapper: {
        backgroundColor: (props) => props?.settings_colors_viewer?.screen_background_color || whiteColor,
    },
    companyLink: {
        textDecoration: 'none',
        textAlign: 'center',
        outline: 'none',
        cursor: 'pointer',
    },
    poster: {
        maxWidth: '100%',
        maxHeight: '560px',
        display: 'block',
        margin: 'auto',
        borderRadius: '16px',
    },
    name: {
        marginBottom: '10px',
    },
    imageGridItem: {
        alignSelf: 'center',
    },
    descriptionHidden: {
        overflow: 'hidden',
        maxHeight: '105px',
        whiteSpace: 'normal',
    },
    whiteSpaceNormal: {
        whiteSpace: 'normal',
    },
    layoutFirstTable: {
        paddingBottom: '20px',
    },
    layoutFirst: {
        padding: 0,
    },
});

export default organizerPosterListPageStyle;
